import { Component, OnInit } from '@angular/core';
import { expandCollapse } from '../_components/animations/animations';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [ expandCollapse ]    
})
export class HomeComponent implements OnInit {
  faqs: any[] = [
    { question: 'How much do your services cost?', answer: 'Our services are provided free of charge because of generous donors.', isExpanded: false },  
    { question: 'Is this a program?  How long does a mentoring relationship last?', answer: 'Parenting with Purpose is not a program with a graduation.  There is no set timeline for completion.', isExpanded: false },  
    { question: 'How will a mentor help me?', answer: "Your mentor is an experienced mom who wants to listen to your story and learn about your hopes and aspirations.  You will work together to set goals for various aspects of your life.  Meeting together over coffee or lunch (or Zoom), your mentor will provide wisdom to navigate the obstacles facing you in your parenting journey.  If you're feeling upset or scared, you'll have a caring mentor to text or call.  Your mentor will do what it takes to help you become the best parent you can be.", isExpanded: false }
  ];

  constructor() { }

  ngOnInit(): void {
  }

  goToVolunteerPage() {
      window.open("https://equippedparents.servicereef.com/events", '_blank');
  }
}
